export default __webpack_public_path__ + "d37460d353330a1ae0ea281c37b02a03.ttf";